import { render, staticRenderFns } from "./BaseOverlayMenuListItemPhase2.9.vue?vue&type=template&id=486807db"
import script from "./BaseOverlayMenuListItemPhase2.9.vue?vue&type=script&lang=js"
export * from "./BaseOverlayMenuListItemPhase2.9.vue?vue&type=script&lang=js"
import style0 from "./BaseOverlayMenuListItemPhase2.9.vue?vue&type=style&index=0&id=486807db&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports